import { Component, Input, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";

@Component({
  selector: "app-modal-detalhes-consolidacao-indicadores-aps",
  templateUrl: "./modal-detalhes-consolidacao-indicadores-aps.component.html",
  styleUrls: ["./modal-detalhes-consolidacao-indicadores-aps.component.css"],
})
export class ModalDetalhesConsolidacaoIndicadoresApsComponent
  implements OnInit
{
  @Input() dado: any = {};
  @Input() tipoIndicador: string;
  @Input() equipe: string;
  constructor(public bsModalRef: BsModalRef) {}

  ngOnInit() {
    this.tipoIndicador = this.tipoIndicador.toUpperCase().replace(/_/g, " ");
    
  }

  getCorCelula(valor: number): string {
    if (valor <= 25) {
      return "text-indicador-vermelho";
    } else if (valor > 25 && valor <= 50) {
      return "text-indicador-amarelo";
    } else if (valor > 50 && valor <= 75) {
      return "text-indicador-verde";
    } else if (valor > 75 && valor <= 100) {
      return "text-indicador-azul";
    }
  }
  
}
